import React, { useContext } from 'react';
import classNames from 'classnames';
import { FILTER } from '@fiverr-private/listing_lib';
import { AppContext } from '../../../../../context/listingsContext';
import { getFilterById } from '../../../../util';
import BusinessProToggle from './business_pro_toggle';
import ProToggle from './pro_toggle';
import { toggleFiltersStyles } from './toggleFilters.ve.css';
import { OnlineNowToggle } from './online_now_toggle';

const ToggleFilters = ({ filters }) => {
    const { isBusiness, inOwlsSideFiltersTest } = useContext(AppContext);

    const ContextualToggle = () => {
        if (isBusiness) {
            return <BusinessProToggle {...getFilterById(filters, FILTER.PRO.ID)} source="toggle_filters" />;
        }

        return <ProToggle tooltip filter={getFilterById(filters, FILTER.PRO.ID)} source="toggle_filters" />;
    };

    const SecondaryToggle = () => (
        <OnlineNowToggle tooltip filter={getFilterById(filters, FILTER.IS_SELLER_ONLINE.ID)} source="toggle_filters" />
    );

    return (
        <div
            className={classNames('togglers-wrapper', 'flex', 'flex-items-baseline', {
                [toggleFiltersStyles]: inOwlsSideFiltersTest,
            })}
        >
            <ContextualToggle />
            <SecondaryToggle />
        </div>
    );
};

export default ToggleFilters;
